module.exports = __webpack_public_path__ + "static/media/open-arrow.077f897d.svg";